import React from "react";

// Import images
import roundDiamond from "../../assets/shapes/round_diamond.jpeg";
import princessCutDiamond from"../../assets/shapes/princess_diamond.jpeg"
import ovalDiamond from"../../assets/shapes/oval_diamond.png";
import emeraldDiamond from"../../assets/shapes/emerald_diamond.png";
import marquiseDiamond from"../../assets/shapes/marquise_diamond.png";
import pearDiamond from"../../assets/shapes/pear_diamond.png";

// Import the CSS file
import "./OurProductsSection.css";

const products = [
  { id: 1, title: "Round Brilliant", imageUrl: roundDiamond },
  { id: 2, title: "Princess Cut", imageUrl: princessCutDiamond },
  { id: 3, title: "Oval", imageUrl: ovalDiamond },
  { id: 4, title: "Emerald Cut", imageUrl: emeraldDiamond },
  { id: 6, title: "Pear Shape", imageUrl: pearDiamond },
  { id: 5, title: "Marquise Cut", imageUrl: marquiseDiamond },
];

const OurProductsSection = () => {
  return (
    <section className="our-products-section">
      <div className="container2">
        <h2 className="sec-title">Exquisite Diamond Collection</h2>
        <div className="products-grid">
          {products.map((product, index) => (
            <div
              key={product.id}
              className="product-card1 fade-in-up1"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img
                src={product.imageUrl}
                alt={product.title}
                className="product-image"
              />
              <div className="product-overlay">
                <p className="product-title">{product.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurProductsSection;
